<div
  ngbDropdown
  class="hub-operations"
  placement="bottom-start"
  autoClose="outside"
  container="body"
  #operationsDropdown="ngbDropdown">
  <hub-button
    type="primaryOutline"
    ngbDropdownToggle
    icon="icon-operations hub-m-0"
    iconSize="24"
    customClass="hub-fs-14 hub-d-flex hub-align-items-center hub-px-0-5 hub-rounded-1"
    [isDisabled]="toastCount() === 0">
    <span>Operations</span>
    @if (toastCount() > 0) {
    <span class="hub-operations--toggle-badge"> {{ toastCount() }} </span>
    }
  </hub-button>

  <div
    ngbDropdownMenu
    class="hub-operations--dropdown"
    [class.hub-operations--dropdown-expanded]="hasExpandedToast()"
    aria-labelledby="operations-dropdown-btn">
    @if (toastCount() > 0) {
    <div class="hub-operations--list">
      @for (toast of toasts(); track toast.id) {
      <div
        class="hub-operations--item"
        [class.hub-operations--item-expanded]="toast.isExpanded"
        [class.hub-operations--item-success]="toast.type === OperationToastType.SUCCESS"
        [class.hub-operations--item-error]="toast.type === OperationToastType.ERROR"
        [class.hub-operations--item-warning]="toast.type === OperationToastType.WARNING"
        [class.hub-operations--item-info]="!toast.type || toast.type === OperationToastType.INFO"
        [class.hub-operations--item-processing]="toast.isProcessing"
        [class.hub-operations--item-noprogress]="!toast.isProcessing">
        <div class="hub-operations--item-content">
          <div class="hub-operations--item-icon">
            <div
              class="hub-operations--item-icon-solid"
              [class.blinking]="toast.isProcessing"></div>
          </div>
          <div class="hub-operations--item-text">
            @if (toast.title) {
            <div class="hub-operations--item-title" [innerHTML]="toast.title"></div>
            } @if (toast.description && toast.isExpanded) {
            <div class="hub-operations--item-description" [innerHTML]="toast.description"></div>
            } @if (!toast.title && !toast.description) {
            <div class="hub-operations--item-body">
              @if (isTemplate(toast)) {
              <ng-template [ngTemplateOutlet]="$any(toast.textOrTpl)" />
              } @else { {{ toast.textOrTpl }} }
            </div>
            }

            @if (toast.actions && toast.actions.length > 0) {
              <span class="hub-operations--item-content-actions">
                @for (action of toast.actions; track $index) {
                <hub-button
                  type="small"
                  [customClass]="'hub-shadow-none' + (action.buttonClass || 'btn-primary')"
                  [icon]="action.icon ?? ''"
                  (clicked)="action.handler()">
                  {{ action.label }}
                </hub-button>
                }
              </span>
              }
          </div>
          <div class="hub-operations--item-actions">
            @if (toast.description) {
            <hub-button
              type="iconWhite"
              (clicked)="onExpand(toast)"
              [attr.aria-label]="toast.isExpanded ? 'Collapse' : 'Expand'"
              [icon]="toast.isExpanded ? 'icon-maximize' : 'icon-minimize'" />
            }
            <hub-button
              type="iconWhite"
              (clicked)="onClose(toast)"
              aria-label="Close"
              icon="icon-x" />
          </div>
        </div>
      </div>
      }
    </div>
    }
  </div>
</div>
